import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Checkbox} from "semantic-ui-react";
import {Link} from "react-router-dom";
import MARVEL from "../../../common/utils/MarvelUrls";
import {BGSortFields} from "../constants/BillingGroupActionConstants";
import LastUpdated from "../../../common/partials/LastUpdated";

export class BillingGroupsListRow extends React.Component {

    static propTypes = {
        key: PropTypes.number,
        billingGroupID: PropTypes.string,
        billingGroupName: PropTypes.string,
        billingGroupInvoiceName: PropTypes.string,
        billingGroupCurrency: PropTypes.string,
        billingGroupBasePrice: PropTypes.number,
        billingGroupCountryCount: PropTypes.number,
        billingGroupServicesCount: PropTypes.number,
        billingGroupVolumeAggregation: PropTypes.string,
        billingGroupLastUpdated: PropTypes.string
    }

    get checkbox() {
        return (
            <td className="low-width">
                <Checkbox
                    disabled
                    checked={this.props.isSelected}
                />
            </td>
        );
    }

    get billingGroupName() {
        const { billingGroupID, billingGroupName, billingGroupInvoiceName, bgSortKey } = this.props;
        const isSharedName = billingGroupName === billingGroupInvoiceName;
        let classnames = ""
        if (bgSortKey === BGSortFields.BG_NAME) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <Link to={{pathname: MARVEL.VERITAS.billing_groups + billingGroupID}} key={billingGroupID}>
                    <p>
                    {isSharedName ?
                        <strong>{billingGroupName}</strong>
                        : <><strong>{billingGroupName}</strong><br /><em>{billingGroupInvoiceName}</em></>}
                    </p>
                </Link>
            </td>
        );
    }

    get billingGroupBasePrice() {
        const { billingGroupCurrency, billingGroupBasePrice, bgSortKey } = this.props;
        let classnames = ""
        if (bgSortKey === BGSortFields.BASE_PRICE) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <p>{billingGroupCurrency} {billingGroupBasePrice}</p>
            </td>
        );
    }

    get billingGroupCountryCount() {
        const { billingGroupCountryCount, bgSortKey } = this.props;
        let classnames = ""
        if (bgSortKey === BGSortFields.COUNTRY_COUNT) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <p>{billingGroupCountryCount}</p>
            </td>
        );
    }

    get billingGroupServicesCount() {
        const { billingGroupServicesCount, bgSortKey } = this.props;
        let classnames = ""
        if (bgSortKey === BGSortFields.SERVICES_COUNT) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <p>{billingGroupServicesCount}</p>
            </td>
        );
    }

    get billingGroupVolumeAggregation() {
        const { billingGroupVolumeAggregation, bgSortKey } = this.props;
        let classnames = ""
        if (bgSortKey === BGSortFields.VOLUME_AGGREGATION) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <p>{billingGroupVolumeAggregation}</p>
            </td>
        );
    }

    get billingGroupLastUpdated() {
        const { billingGroupLastUpdated, bgSortKey } = this.props;
        let lastUpdatedElement;
        let classnames = "";
        if (bgSortKey === BGSortFields.LAST_UPDATED) {
            classnames += "current-sort";
        }
        if (billingGroupLastUpdated === null) {
            lastUpdatedElement = '';
        } else {
            lastUpdatedElement = <LastUpdated lastUpdated={billingGroupLastUpdated} type="medium" />;
        }
        return (
            <td className={classnames}>
                {lastUpdatedElement}
            </td>
        )
    }

    render() {

        return (
            <tr>
                {this.checkbox}
                {this.billingGroupName}
                {this.billingGroupBasePrice}
                {this.billingGroupCountryCount}
                {this.billingGroupServicesCount}
                {this.billingGroupVolumeAggregation}
                {this.billingGroupLastUpdated}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    bgSortKey: state.veritas.billingGroups.bgSortKey,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingGroupsListRow)
